import PlatformActions from './PlatformActions'

export default class COOLGAMEActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      platform: 'COOLGAME',
      gameType: 'TABLE',
      gameCode: 'COOLGAME-TABLE-002',
    }

    this.gameName = 'TeenPatti'
    this.preserveAmount = 2560
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betTime,
      betAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: txnId, // 6ac0321be1e34052a7e6ee0b881a0ac9
      roundId, // 06ce48d46d2c4f44b4e9885dc109ce14
      betType: null,
      currency,
      betTime, // 2025-08-19T17:59:36.334+08:00
      betAmount,
      jackpotBetAmount: 0,
      gameInfo: {
        gameId: 201,
      },
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const { betAmount: formBetAmount } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
      settleAmount,
      preserveAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: txnId, // 6ac0321be1e34052a7e6ee0b881a0ac9
      refPlatformTxId: null,
      settleType: 'platformTxId',
      updateTime, // 2025-08-19T17:59:57.290+08:00
      roundId,
      betType: null,
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      jackpotWinAmount: 0,
      gameInfo: {
        betAmount: formBetAmount,
        preserveAmount,
        settleAmount,
      },
    }))

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: `${txnId}`,
      roundId,
      gameInfo: {
        gameId: 201,
      },
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }
}
